/*
    Add here your own custom javascript
*/

/* Mindful Fit: keep the header cart count in sync after any cart change (2026-10-24) */
(function () {
  if (window.__mfCartCountSync) return;
  window.__mfCartCountSync = true;

  var timer = null;
  var lateTimer = null;

  function setCount(count) {
    document.querySelectorAll('.cart-counting-prodiuct, .cart-count-badge').forEach(function (el) {
      el.textContent = count;
      el.removeAttribute('hidden');
    });
  }

  function syncCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCount(cart.item_count); })
      .catch(function () {});
  }

  function scheduleSync() {
    clearTimeout(timer);
    clearTimeout(lateTimer);
    timer = setTimeout(syncCount, 150);
    /* second pass picks up items added by apps afterwards, e.g. the free e-book */
    lateTimer = setTimeout(syncCount, 1800);
  }

  function wrapRefresh() {
    var original = window.refreshCartContents;
    if (typeof original !== 'function' || original.__mfWrapped) return false;
    var wrapped = function () {
      var result;
      try {
        result = original.apply(this, arguments);
      } catch (e) {
        scheduleSync();
        throw e;
      }
      Promise.resolve(result).then(scheduleSync, scheduleSync);
      return result;
    };
    wrapped.__mfWrapped = true;
    window.refreshCartContents = wrapped;
    return true;
  }

  if (!wrapRefresh()) {
    document.addEventListener('DOMContentLoaded', wrapRefresh);
  }
  window.addEventListener('updated.ecomify.cart', scheduleSync);
  document.documentElement.addEventListener('cart:refresh', scheduleSync);
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncCount(); });
})();
